import TabScroll from './components/TabScroll';
export { default as Container } from './components/container';
export { default as IframeContainer } from './components/iframeContainer';
export { default as ChineseProvider } from './components/ChineseProvider';
export { default as UploadImage } from './components/UploadImage';
export { default as TabScroll } from './components/TabScroll';
const { TabPane } = TabScroll;
export { TabPane };
export { default as FixedOpt } from './components/FixedOpt';
export { default as Echarts } from './components/Echarts';
export { default as StoreTableSelect } from './components/StoreTableSelect';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
